// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"436":"b8f2ae27","641":"8d80b561"}[chunkId] + ".chunk.js";
};